import React from 'react'
import './Seafreight.css'

function Seafreight() {
  return (
      <div className="seafreight-services-container">
      {/* Hero section with image and overlay text */}
      <div className="seafreight-services-hero">
        <div className="seafreight-services-overlay">
          <h1>Sea Freight</h1>
        </div>
      </div>
      {/* White gap */}
      <div className="white-gap"></div>
       {/* Content section with image and text */}
      <div className="seafreight-content">
        <div className="seafreight-image">
          <img src="/Pics/seafreight.jpg" alt="Full Logistics Services" />
        </div>
        
        <p>
          Centrex marine services is one of the foremost box operator (NVOCC) and freight forwarders offering a variety of choices from importing to exporting goods worldwide by means of ocean freight forwarding. Our competent team and associated agents make sure to facilitate the transportation of your shipment from its source nation to the destination nation via sea routes in either import or export.
        </p>
        
        <p>
          We have a strong network of liners and partners that allow us to offer our services to all major destinations worldwide. We have a team of professionals onboard who prioritize customer satisfaction and are always available to make sure that your cargo reaches you in the right place at the right time.
        </p>
        
        <p>
          A diverse array of global cargo import/export services are offered by Centrex marine services. By skillfully managing various cargo sizes via LCL and FCL services, we guarantee reasonable pricing for all transport demands. In the freight business, our company boasts unparalleled networks to serve client needs supremely well. From international scope to fine-tuned mergers, we deliver bottom-line value across every facet of cargo transport.
        </p>
        
        <p>
          Strengthening our assistance in transportation management with seamless connectivity across regions, we enable the provisioning of efficient export freight solutions, encompassing consignments' arrangement and safe passage via our formidable rail and land routes leading to various destinations within Pakistan.
        </p>
        
        <p>
          By entrusting us with such responsibilities, we make sure your goods enjoy optimal delivery expenses attained through trustworthy industry connections formed on your behalf. Utilizing our proficiency in both environments allows us to deliver optimal pricing options best suited for international trade.
        </p>
        
        <p>
          A comprehensive response system, functioning tirelessly around the clock, anticipates your needs. Never hesitate to reach us if you require assistance, as we prioritize delivering maximum satisfaction for every penny spent.
        </p>
      </div>
      </div>
  )
}

export default Seafreight